<template>
  <div :class="{'content-wrapper':remove == false}">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          v-if="remove == false"
          :page-title="$t('company_details')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
    </div>
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
  </div>
</template>
<script>
import CopyButton from "../../../../Demo/UI/CopyButton.vue";
import * as actions from "../../../../../../Config/ApiUrl";
import {
  axiosGet,
} from "../../../../../../Helpers/AxiosHelper";


export default {
  name: "Tabs",
  components: { CopyButton },
  props:{
    certificateId: {type: [String,Number]},
    companyId: {type: [String,Number]},
    remove: Boolean,
    userId: {type: [String,Number], default: null},
    type: {type: [String], default:''},
  },
  data() {
    return {
      icon: "settings",
      isAddEditModalActive: false,
      tabsHorizontal: [
        {
          icon: "info",
          name: "Details",
          component: "certificate-details",
          permission: "",
          props: {company_id:this.companyId ?? this.$attrs.companyid, certificate_id:this.certificateId ?? this.$attrs.certificateid},
        },
        {
          icon: "info",
          name: "Profile",
          component: "buyer-profile-view",
          permission: this.type == 'training-request' ? false : true,
          props: {company_id:this.companyId ?? this.$attrs.companyid, certificate_id:this.certificateId ?? this.$attrs.certificateid},
        },
        {
          icon: "file-text",
          name: "Form Responses",
          component: "request-company-form-responses",
          permission: "",
          props: {company_id:this.companyId ?? this.$attrs.companyid, 
            certificate_id:this.certificateId ?? this.$attrs.certificateid,
            user_id:this.userId ?? this.$attrs.userId,
            type:this.type ?? this.$attrs.type},
        },
        {
          icon: "file-text",
          name: "Forms",
          component: "request-company-forms",
          permission: "",
          props: {company_id:this.companyId ?? this.$attrs.companyid, user_id:this.userId ?? this.$attrs.userId, certificate_id:this.certificateId ?? this.$attrs.certificateid},
        },
        {
          icon: "download-cloud",
          name: "Certificate Document",
          component: "mydocument-index",
          permission: "",
        },
        // {
        //   icon: "file-text",
        //   name: "Document",
        //   component: "job-document",
        //   permission: "",
        // },
        // {
        //   icon: "message-square",
        //   name: "Conversation",
        //   component: "job-chat",
        //   permission: "",
        // },
        // {
        //   icon: "link",
        //   name: "Sites",
        //   component: "site-view",
        //   permission: "",
        // },
        // {
        //   icon: "message-circle",
        //   name: "Notes",
        //   component: "job-notes",
        //   permission: "",
        // },
        // {
        //   icon: "users",
        //   name: "Bids",
        //   component: "job-bids",
        //   permission: "",
        // },
      ],
    };
  },
  // beforeCreate() {
  //   if (this.remove == undefined) {
  //     this.remove = true;
  //   }
  //   // this.certificateInfo();
  // },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal(certificate_id) {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },
    certificateInfo() {
      console.log('test '+ this.$attrs.certificateid);
      return this.$attrs.certificateid;
      // var currentURL = window.location.href;
      // // Split the URL by '/' and get the last segment
      // var segments = currentURL.split('/');
      // var value = segments[segments.length - 1];
      // var certificate_id = value.split('?')[0];
      // axiosGet(actions.APPLY_CERTIFICATE_INFO + '/' + certificate_id)
      //   .then((response) => {
      //       this.request_company_id = response.data.data.company_id;  
      //       this.request_certificate_id = response.data.data.compliance_certificate_id; 
      //   })
      //   .catch((error) => {
      //     this.$toastr.e(error);
      //     throw error; // Rethrow the error to propagate it
      //   });
    },
    company_Id() {
      return this.$attrs.companyid;
    },
    // certificate_Id() {
    //   var certificate_id = location.search.split('certificate_id=')[1];

    //   return axiosGet(actions.APPLY_CERTIFICATE_INFO + '?certificate_id=' + certificate_id)
    //     .then((response) => {
    //       return response.data.data.compliance_certificate_id;
    //     })
    //     .catch((error) => {
    //       this.$toastr.e(error);
    //       throw error; // Rethrow the error to propagate it
    //     });
    // }
  },
  mounted() {
    console.log(this.$attrs.certificateid+' '+ this.request_certificate_id);
        // this.certificateInfo();
        //   this.tabsHorizontal.forEach((element) => {
        //       element.props.certificate_id = this.request_certificate_id;
        //       element.props.company_id = this.request_company_id;
        //   });
    },
  computed: {
    userList() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
